import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import FileRepository from '@ckeditor/ckeditor5-upload/src/filerepository';
import IpsImageUpload from "./ips-image-upload";

export default class IpsImagePasteDrop extends Plugin {
    static get requires() {
        return [FileRepository];
    }

    init() {
        const editor = this.editor;
        editor.plugins.get(FileRepository).createUploadAdapter = loader => {
            return new IpsImageUpload(loader, editor);
        };
    }
}
